// extracted by mini-css-extract-plugin
module.exports = {"align_center":"IdentificationStyles_align_center__2pnQC","col":"IdentificationStyles_col__u9ctd","buttonsContainer":"IdentificationStyles_buttonsContainer__2fiyF"};